/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { DeviceOSType, CommonDeviceType } from '../../platform-detector/platform-detector';

export const UndefinedString = 'undefined';

export interface FileListItem {
    name: string;
    type: string;
}

export enum ClientType {
    Native = 'Native',
    Browser = 'Browser',
    GFNSDK = 'GFNSDK',
    Undefined = 'undefined'
}

export enum ClientVariant {
    iBeta = 'iBeta',
    Release = 'Release',
    Undefined = 'undefined'
}

export interface GfcEventsCommonData {
    feedbackId?: string;
    feedbackName?: string;
    clientTs?: string;
    clientId?: string;
    clientVer?: string;
    feedbackSchemaVer?: string;
    feedbackSysVer?: string;
    feedbackProtocol?: string;
    deviceId?: string;
    userId?: string;
    externalUserId?: string;
    idpId?: string;
    sessionId?: string;
    sentTs?: string;
    gdprFuncOptIn?: string;
    gdprTechOptIn?: string;
    gdprBehOptIn?: string;
    deviceGdprFuncOptIn?: string;
    deviceGdprTechOptIn?: string;
    deviceGdprBehOptIn?: string;
    fileList?: FileListItem[];
    deviceOS?: DeviceOSType;
    deviceOSVersion?: string;
    deviceType?: CommonDeviceType;
    deviceModel?: string;
    deviceMake?: string;
    clientType?: ClientType;
    clientVariant?: ClientVariant;
    browserType?: string;
    integrationId?: string;
    productName?: string;
    productVersion?: string;
    cpuArchitecture?: string;
}

export enum ConsentLevel {
    Full = 'Full',
    None = 'None',
    Temp = 'Temp'
}

export interface UserConsent {
    functional: ConsentLevel;
    technical: ConsentLevel;
    behavioral: ConsentLevel;
}

export interface UserConsentInfo {
    userId: string;
    externalUserId: string;
    idpId: string;
    userConsent: UserConsent;
    expiryTime?: string;
}

export interface LogChunkParams {
    isBrowserClosing: boolean;
    prevChunkInProgress?: boolean;
}

export interface LogChunk {
    logString: string;
    isLastChunk: boolean;
    params?: LogChunkParams;
}

export interface WebWorkerTimerNotificationData {
    startTimer: boolean;
    timeout: number;
}

export interface WebWorkerIntervalNotificationData {
    startInterval: boolean;
    tickInterval: number;
}

export interface FeedbackDef {
    [key: string]: any;
    parameters: any;
}

export interface EventParams {
    appInstanceId?: string;
    streamSessionId?: string;
    streamSubSessionId?: string;
    surveySessionId?: string;
}
